module.exports={Component:require("./propedit")};